// Parse data from <script> node
export default key => {
  const node = document.getElementById(key)

  if (!node) {
    return null
  }

  const type = node.getAttribute('type')

  if ('text/plain' === type) {
    return node.innerText
  }

  if ('application/json' === type) {
    return JSON.parse(node.innerHTML)
  }

  return null
}
